import React from 'react'
import { ReactComponent as FilesIcon } from '@assets/images/Icons/Empty_state_files.svg'
import Button from '../Button/Button.component'
import type { EmptyStateProps } from './EmptyState.types'
import {
  EMPTY_STATE_DEMO_ACTION_LABEL,
  EMPTY_STATE_DEMO_DESCRIPTION,
  EMPTY_STATE_DEMO_TITLE,
} from './EmptyState.types'
import './EmptyState.css'

const EmptyState: React.FC<EmptyStateProps> = ({
  title = EMPTY_STATE_DEMO_TITLE,
  description = EMPTY_STATE_DEMO_DESCRIPTION,
  iconClass,
  illustration,
  actionLabel,
  onAction,
  className = '',
  darkMode = false,
  outlined = false,
  previewState,
}) => {
  const isPreview = previewState != null
  const showAction =
    previewState === 'no-action'
      ? false
      : previewState === 'with-action' ||
        previewState === 'default' ||
        (Boolean(actionLabel) && (onAction != null || isPreview))
  const resolvedActionLabel =
    actionLabel ?? (showAction ? EMPTY_STATE_DEMO_ACTION_LABEL : undefined)

  const classNames = [
    'ds-empty-state',
    darkMode ? 'ds-empty-state--dark' : '',
    outlined ? 'ds-empty-state--outlined' : '',
    isPreview ? 'ds-empty-state--preview' : '',
    previewState ? `ds-empty-state--preview-${previewState}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  let media: React.ReactNode = (
    <FilesIcon
      className="ds-empty-state__graphic"
      width={88}
      height={88}
      aria-hidden="true"
    />
  )
  if (illustration) {
    media = <div className="ds-empty-state__illustration">{illustration}</div>
  } else if (iconClass) {
    media = (
      <i className={`ds-empty-state__icon ${iconClass}`} aria-hidden="true" />
    )
  }

  return (
    <div className={classNames} data-preview-state={previewState}>
      <div className="ds-empty-state__content">
        {media}
        {title ? <h3 className="ds-empty-state__title">{title}</h3> : null}
        {description ? (
          <p className="ds-empty-state__description">{description}</p>
        ) : null}
        {showAction && resolvedActionLabel ? (
          <div className="ds-empty-state__action">
            <Button
              variant="primary"
              size="md"
              label={resolvedActionLabel}
              darkMode={darkMode}
              onClick={isPreview ? undefined : onAction}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default EmptyState
